import React from 'react';
import styled from 'styled-components'
import {
    defaults,
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
} from 'chart.js';
import { getRelativePosition } from 'chart.js/helpers';
import { Line, Bar, getElementsAtEvent } from 'react-chartjs-2';
import { format, sub, eachDayOfInterval } from 'date-fns'

import { dark, light } from 'theme'

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Filler
);
defaults.font.family = 'Courier New'
defaults.font.weight = 'bold'
// defaults.elements.line.fill = "origin";

const Container = styled.div`
    width: ${props => props.width};
    height: ${props => props.height};
    position: relative;
`

const Chart = props => {
    const {
        type,
        data,
        labels,
        title,
        theme,
        options,
        showSecondaryAxis,
        showGridLines = true,
        onSelect,
        height = '30vh',
        width = '100%'
    } = props;
    const themeRef = theme === 'Dark' ? dark : light
    const chartRef = React.useRef()

    const getOptions = (values) => {
        return ({
            responsive: true,
            maintainAspectRatio: false,
            stacked: false,
            lineTension: 0.4,
            interaction: {
                mode: 'index',
                intersect: false
            },
            plugins: {
                legend: {
                    display: false,
                },
                title: {
                    display: title,
                    text: title,
                },
            },
            scales: {
                xAxis: {
                    display: true,
                    min: 0,
                    ticks: {
                        autoSkip: true,
                        autoSkipPadding: 10,
                        maxRotation: 0,
                        minRotation: 0,
                        align: 'start',
                        // align: 'center',
                        min: 0,
                    },
                    scaleLabel: {
                        display: false,
                        labelString: "Date",
                    },
                    grid: {
                        borderColor: themeRef['--secondary-color'],
                        tickColor: themeRef['--secondary-color'],
                        color: themeRef['--primary-accent-color'],
                        drawTicks: true,
                        drawOnChartArea: true,
                        display: showGridLines || false
                        // lineWidth: 2,
                        // borderWidth: 2,
                    },
                },
                y: {
                    id: values[0]['yAxisID'],
                    display: true,
                    min: values[0]['yMin'] || 0,
                    max: values[0]['yMax'],
                    ticks: {
                        display: true,
                        beginAtZero: true,
                        min: 0,
                        autoSkip: true,
                        autoSkipPadding: 20,
                    },
                    grid: {
                        borderColor: themeRef['--primary-accent-color'],
                        tickColor: themeRef['--primary-accent-color'],
                        color: themeRef['--primary-accent-color'],
                        drawTicks: true,
                        drawOnChartArea: true,
                        display: showGridLines || false,
                        drawBorder: false
                        // lineWidth: 2,
                        // borderWidth: 2,
                    },
                    title: {
                        display: values[0]['yAxisLabel'] ? true : false,
                        text: values[0]['yAxisLabel']
                    },
                },
                y2: values[1] && showSecondaryAxis && {
                    id: values[1] && values[1]['yAxisID'],
                    position: 'right',
                    display: true,
                    min: values[0] && values[0]['yMin'] || 0,
                    max: values[0] && values[0]['yMax'] || 10,
                    ticks: {
                        display: true,
                        beginAtZero: true,
                    },
                    grid: {
                        borderColor: themeRef['--primary-accent-color'],
                        tickColor: themeRef['--primary-accent-color'],
                        drawTicks: true,
                        drawOnChartArea: false,
                        display: showGridLines || false,
                        drawBorder: false
                    },
                    title: {
                        display: values[1] && values[1]['yAxisLabel'] ? true : false,
                        text: values[1] && values[1]['yAxisLabel']
                    },
                },
            },
            annotation: {
                annotations: [],
            },
            onHover: (event, chartElement) => {
                // console.log(chartElement)
                const target = event.native ? event.native.target : event.target;
                target.style.cursor = chartElement[0] ? 'pointer' : 'default';
            },
            onClick: (e) => {
                const canvasPosition = getRelativePosition(e, chartRef.current);
    
                // Substitute the appropriate scale IDs
                const x = chartRef.current.scales.xAxis.getValueForPixel(canvasPosition.x);
                onSelect && onSelect({label: labels[x], index: x, values})
            }
        })
    };

    const onSelectChart = (event) => {
        const chart = chartRef && chartRef.current
        if(chart){
            const x = getElementsAtEvent(chart, event)[0] && getElementsAtEvent(chart, event)[0]['index']
            console.log(x)
            if(x){
                let values = {}
                Object.values(data).forEach(chartData => {
                    values[chartData['label']] = chartData['data'][x]
                })
                onSelect && onSelect({label: labels[x], index: x, values})
            }
        }   
    }

    if(!data){ return }

    let content;
    const chartOptions = getOptions(data)
    switch(type){
        case 'LINE':
            content = <Line ref={chartRef}
                        // onClick={(event) => onSelectChart(event, labels)}
                        options={chartOptions} 
                        data={{
                            labels,
                            datasets: data.map((values, index) => ({
                                ...values,
                                borderWidth: 2,
                                radius: 1,
                                hoverRadius: 5,
                                hitRadius: 5,
                                // fill: false,
                                // backgroundColor: 'transparent'
                                // fill: {
                                //     target: index === 1 ? 'origin' : false,
                                //     // above: 'rgb(242,242,242,0.1)',  
                                // }
                            }))
                        }}/>
            break
    }

    return (
        <Container height={height} width={width}>
            {content}
        </Container>
    )
}

export default Chart